import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Blade } from "../../../components/Blade";
import { CharacterListBladeSchema } from "../../../schemas/blades/CharacterCardGrid";
import { BladeContent } from "../../../components/BladeContent";
import { BladeHeaderDefault } from "../../../molecules/BladeHeaderDefault";
import { CharacterCard } from "..";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
export const CharacterCardGridContractSchema = CharacterListBladeSchema.extend({
    type: z.literal("characterCardGrid"),
});
export const Grid = styled.div ``;
const _CharacterCardGrid = ({ header, backdrop, items, ...otherProps }) => {
    const { background, foreground } = backdrop || {};
    return (React.createElement(Blade, { "data-testid": "character-card-grid", ...otherProps },
        React.createElement(Backdrop, null,
            background && (React.createElement(BackdropBackground, null,
                React.createElement(Media, { media: background, role: "presentation" }))),
            foreground && (React.createElement(BackdropForeground, null,
                React.createElement(Media, { media: foreground, role: "presentation" })))),
        React.createElement(BladeContent, { width: "large" },
            React.createElement(BladeHeaderDefault, { ...header }),
            React.createElement(Grid, { "data-testid": "card-grid" }, items.map((item, index) => (React.createElement(CharacterCard, { key: index, ...item })))))));
};
export const CharacterCardGrid = styled(_CharacterCardGrid) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=CharacterCardGrid.js.map